<!-- 前置仓 -->
<template>
  <div class="warp">
    <div class="banner">
      <br />
      <p>前置仓电商供应链系统</p>
      <span>
        提供全面的“前置仓电商
        <br />+供应链管理”解决方案
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="item1">
      <div
        class="tis"
      >绿茶前置仓电商供应链应链系统，结合配送端、门店端、后端供应链和仓储管理，全面提升仓储和订单流转的工作效率，通过共享物流、仓储、配送等资源，使区域配送更加快速、高效。</div>
      <div class="title">业务架构</div>
      <div class="list">
        <div class="subtitle">前台</div>
        <div class="box">
          <div class="boxtitle">电商(小程序/APP/H5)</div>
          <ul>
            <li>商品信息</li>
            <li>搜索</li>
            <li>会员信息</li>
            <li>营销管理</li>
            <li>评论管理</li>
            <li>订单管理</li>
            <li>配送管理</li>
            <li>物流信息</li>
            <li>购物车</li>
            <li>商户管理</li>
          </ul>
        </div>
        <div class="box">
          <div class="boxtitle">骑手配送</div>
          <ul>
            <li>订单配送</li>
            <li>地图轨迹</li>
          </ul>
        </div>
        <div class="box">
          <div class="boxtitle">前置仓/(自营店/加盟店)</div>
          <ul class="list1">
            <li>商品库存</li>
            <li>商品清货</li>
            <li>库存调拨</li>
            <li>采购入库</li>
            <li>收银</li>
            <li>销售出库</li>
          </ul>
        </div>
      </div>

      <div class="list">
        <br />
        <div class="subtitle">中台</div>
        <div class="box">
          <ul>
            <li>商品管理</li>
            <li>促销管理</li>
            <li>营销管理</li>
            <li>订单管理</li>
            <li>会员管理</li>
            <li>支付管理</li>
            <li>自营店管理</li>
            <li>售后管理</li>
            <li>操作日志</li>
            <li>统计报表</li>
            <li>权限管理</li>
            <li>系统管理</li>
            <li>系统管理</li>
            <li>对账管理</li>
            <li>加盟店管理</li>
          </ul>
        </div>
      </div>

      <div class="list">
        <br />
        <div class="subtitle">后台</div>
        <div class="box">
          <div class="boxtitle">供应链</div>
          <ul>
            <li>采购管理</li>
            <li>加盟店结算</li>
            <li>店铺管理</li>
            <li>商品信息管理</li>
            <li>配送员管理</li>
            <li>供应商管理</li>
            <li>供应商结算</li>
            <li>配送管理</li>
            <li>操作员管理</li>
            <li>接口设置</li>
          </ul>
        </div>

        <div class="box">
          <div class="boxtitle">仓储管理</div>
          <ul class="list1">
            <li>仓库管理</li>
            <li>退货管理</li>
            <li>商品拣货</li>
            <li>库存调拨</li>
            <li>商品发货</li>
            <li>货位管理</li>
          </ul>
        </div>

        <div class="box">
          <div class="boxtitle">会员管理</div>
          <ul class="list1">
            <li>会员管理</li>
            <li>会员售后</li>
            <li>用户轨迹</li>
            <li>精准推送</li>
            <li>用户标签</li>
            <li>会员营销</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="item2">
      <div class="title">业务流程</div>
      <div class>
        <img style="width:100%" src="../../assets/images/warehouse02.jpg" />
      </div>
    </div>

    <div class="item3">
      <div class="title">产品优势</div>
      <div class="t" style="background-color:#fff;">
        <div class="t1">
          <img src="../../assets/images/warehouse03.jpg" />
        </div>
        <div class="t2">
          <p style="color:#0084b3">线上线下一体化管理，全渠道触网</p>
          <span style="background-color:#0084b3"></span>
        </div>
        <ul class="t3">
          <li>
            <img src="../../assets/images/warehouse01.png" />
            <span>订单秒级同步，实时管控门店库存</span>
          </li>
          <li>
            <img src="../../assets/images/warehouse02.png" />
            <span>自动计算补货，系统审单高效无忧</span>
          </li>
          <li>
            <img src="../../assets/images/warehouse03.png" />
            <span>打通渠道壁垒，只智能调控库存共享</span>
          </li>
        </ul>
      </div>
      <div class="t" style="background-color:#f1f2f4;">
        <div class="t1">
          <img src="../../assets/images/warehouse04.jpg" />
        </div>
        <div class="t2">
          <p style="color:#2d61bf">库存清点智能化，告别混乱管理</p>
          <span style="background-color:#2d61bf"></span>
        </div>
        <ul class="t3">
          <li>
            <img src="../../assets/images/warehouse04.png" />
            <span>商品入库清点自动化，避免漏捡错捡</span>
          </li>
          <li>
            <img src="../../assets/images/warehouse05.png" />
            <span>实时追踪采购出入货，无需人工登记</span>
          </li>
          <li>
            <img src="../../assets/images/warehouse06.png" />
            <span>订单审核精细化管理，交易严格管控</span>
          </li>
        </ul>
      </div>

      <div class="t" style="background-color:#fff;">
        <div class="t1">
          <img src="../../assets/images/warehouse05.jpg" />
        </div>
        <div class="t2">
          <p style="color:#e5680d">智能策略覆盖，降低物流配送成本</p>
          <span style="background-color:#e5680d"></span>
        </div>
        <ul class="t3">
          <li>
            <img src="../../assets/images/warehouse07.png" />
            <span>智能分仓，多仓供应，门店不缺货</span>
          </li>
          <li>
            <img src="../../assets/images/warehouse08.png" />
            <span>智能匹配，就近原则，送货极速达</span>
          </li>
          <li>
            <img src="../../assets/images/warehouse09.png" />
            <span>智能管理，货品分类，拣货更迅速</span>
          </li>
        </ul>
      </div>

      <div class="t" style="background-color:#f1f2f4;">
        <div class="t1">
          <img src="../../assets/images/warehouse06.jpg" />
        </div>
        <div class="t2">
          <p style="color:#df3e38">自动生成数据报表，效益一目了然</p>
          <span style="background-color:#df3e38"></span>
        </div>
        <ul class="t3">
          <li>
            <img src="../../assets/images/warehouse10.png" />
            <span>秒级上传速度，实时记录数据变化</span>
          </li>
          <li>
            <img src="../../assets/images/warehouse11.png" />
            <span>多维数据分析，全面监查门店盈亏</span>
          </li>
          <li>
            <img src="../../assets/images/warehouse12.png" />
            <span>数据同步更新，跨越门店整合上传</span>
          </li>
        </ul>
      </div>

      <div class="t" style="background-color:#fff;">
        <div class="t1">
          <img src="../../assets/images/warehouse07.jpg" />
        </div>
        <div class="t2">
          <p style="color:#274dbf">完善会员体系，提高门店转化率</p>
          <span style="background-color:#274dbf"></span>
        </div>
        <ul class="t3">
          <li>
            <img src="../../assets/images/warehouse13.png" />
            <span>线上线下联动，实现流量融合</span>
          </li>
          <li>
            <img src="../../assets/images/warehouse14.png" />
            <span>多重数据分析，完善用户画像</span>
          </li>
          <li>
            <img src="../../assets/images/warehouse15.png" />
            <span>分析购物行为，提高商品复购</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="item4">
      <div class="title">应用场景</div>
      <div class="img">
        <img src="../../assets/images/warehouse08.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "warehouse",

  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .banner {
    background: url("../../assets/images/warehouse01.jpg") no-repeat left top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: #2d90a9;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #fff;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: .9rem;
      display: block;
    }
  }
  .title {
    font-size: 0.5rem;
    color: #262e43;
    text-align: center;
    padding: 0.5rem 0;
    font-weight: 500;
  }
  .item1 {
    padding: 0.4rem;
    .tis {
      padding: 0.4rem 0 0;
      font-size: 0.34rem;
      color: #666;
      line-height: 0.6rem;
    }
    .list {
      text-align: center;
      .subtitle {
        padding: 0 0.8rem;
        font-size: 0.35rem;
        display: inline-block;
        line-height: 0.8rem;
        color: #000;
        border: 1px solid #000;
        margin-bottom: 0.4rem;
      }
      .box {
        border: 1px dotted #d2d2d2;
        margin-bottom: 0.3rem;
        padding: 0.3rem;
        .boxtitle {
          font-size: 0.32rem;
          color: #dc5c00;
          border: 1px solid #dc5c00;
          width: 4.5rem;
          line-height: 0.8rem;
          display: inline-block;
          margin-bottom: 0.2rem;
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          li {
            width: 20%;
            font-size: 0.3rem;
            line-height: 0.7rem;
            color: #666;
          }
        }
        .list1 {
          li {
            width: 16.6666666%;
          }
        }
      }
    }
  }
  .item3 {
    .t {
      text-align: center;
    }
    .t1 {
      img {
        width: 100%;
      }
    }
    .t2 {
      font-size: 0.44rem;
      span {
        width: 1.2rem;
        height: 2px;
        display: block;
        margin: 0.4rem auto;
      }
    }
    .t3 {
      font-size: 0.32rem;
      line-height: 0.8rem;
      padding-bottom: 1rem;
      img {
        width: 0.5rem;
      }
    }
  }
  .item4 {
    .img {
      text-align: center;
      padding-bottom: 0.5rem;
      img {
        width: 10rem;
        
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/warehouse.vue